import React from 'react';

import terminal from '@images/PaymentProcessing/terminal.png';
import computer from '@images/PaymentProcessing/computer.png';

const Terminals: React.FC = () => {
	return <section id="terminals" className="terminals payments-processing__item scroll-fix">
		<div className="payments-processing__container terminals__container">
			<div className="terminals__image image-block">
				<div className="image-block__img computer-img">
					<img src={computer} alt="Computer" />
				</div>
				<div className="image-block__img terminal-img">
					<img src={terminal} alt="Terminal" />
				</div>
			</div>
			<div className="terminals__text-block text-block">
				<h1 className="text-block__title">Terminals</h1>
				<ul className="text-block__list">
					<li>Contactless NFC payments including Apple Pay®, Google Pay®, Samsung Pay®</li>
					<li>EMV chip cards</li>
					<li>Swipe cards</li>
					<li>Signature Capture</li>
					<li>Electronic Receipts</li>
					<li>WiFi Connectivity</li>
				</ul>
				<a href="/payments-processing#request-demo" className="text-block__link">request a demo</a>
			</div>
		</div>
	</section>;
};

export default Terminals;
